import React from 'react';
import { useDailyChallengeController } from '../hooks/useDailyChallengeController';
import ActiveChallenge from './ActiveChallenge';
import CompletedChallenge from './CompletedChallenge';
import LoadingScreen from './LoadingScreen';

interface DailyChallengeViewProps {
  onShowInstructions: () => void;
  onShowCalendar: () => void;
  selectedDate?: string;
  isCurrentDaily?: boolean;
}

const DailyChallengeView: React.FC<DailyChallengeViewProps> = (props) => {
  const { state, handlers } = useDailyChallengeController(props);

  if (state.restorationLoading || (state.imageLoading && !state.challenge)) {
    return <LoadingScreen />;
  }

  if (state.imageError) {
    return <div className="p-4 text-red-500">{state.imageError}</div>;
  }

  if (!state.challenge || !state.image) {
    return <LoadingScreen />;
  }

  return state.completedChallenge && state.challengeResultData ? (
    <CompletedChallenge state={state} handlers={handlers} />
  ) : (
    <ActiveChallenge state={state} handlers={handlers} />
  );
};

export default DailyChallengeView;
